const theme ={
  pink: '#ff0099',
  orange: '#ec9d4e',
  blue: '#212c92',
  indigo: '#000551',
  gray: '#666666',
  skyblue: '#01aaff',
  redOrange: '#fc1e27',
  black: '#222222',
  white: '#ffffff',

  spacingXs: '0.5rem', /* 8px */
  spacingBase: '1rem', /* 16px */
  spacingMd: '1.25rem', /* 20px */

  textSm: '0.75rem', /* 12px */
  textBase: '1rem', /* 16px */
  textMd: '1.375rem', /* 22px */
  textLg: '2.375rem',  /* 38px */
  containerWidth: '65.625rem', /* 1050px */
  spacingSm: '0.75rem', /* 12px */
}

export default theme;